{
  "about.blocks": "Moderirani serveri",
  "about.contact": "Kontakt:",
  "about.disclaimer": "Mastodon je besplatan softver otvorenog koda i zaštićeni znak kompanije Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Razlog nije naveden",
  "about.domain_blocks.preamble": "Mastodon vam generalno omogućava da vidite sadržaj i komunicirate sa korisnicima sa bilo kog drugog servera u fediverzumu. Ovo su izuzeci koji su napravljeni na ovom serveru.",
  "about.domain_blocks.silenced.explanation": "Nećete videti profile i sadržaj sa ovog servera osim ako ih eksplicitno ne potražite ili ne zapratite neki profil sa servera.",
  "about.domain_blocks.silenced.title": "Ograničen",
  "about.domain_blocks.suspended.explanation": "Podaci sa ovog servera neće se obrađivati, čuvati niti razmenjivati, što će onemogućiti bilo kakvu interakciju ili komunikaciju sa korisnicima sa ovog servera.",
  "about.domain_blocks.suspended.title": "Suspendovan",
  "about.language_label": "Jezik",
  "about.not_available": "Ove informacije nisu dostupne na ovom serveru.",
  "about.powered_by": "Decentralizovana društvena mreža koju pokreće {mastodon}",
  "about.rules": "Pravila servera",
  "account.activity": "Aktivnosti",
  "account.add_or_remove_from_list": "Dodaj ili ukloni sa lista",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Blokiran",
  "account.badges.bot": "Automatizovano",
  "account.badges.group": "Grupa",
  "account.block": "Blokiraj @{name}",
  "account.block_domain": "Blokiraj domen {domain}",
  "account.block_short": "Blokiraj",
  "account.blocked": "Blokiran",
  "account.cancel_follow_request": "Otkaži praćenje",
  "account.copy": "Kopiraj vezu u profil",
  "account.direct": "Privatno pomeni @{name}",
  "account.disable_notifications": "Zaustavi obaveštavanje za objave korisnika @{name}",
  "account.edit_profile": "Uredi profil",
  "account.edit_profile_short": "Uredi",
  "account.enable_notifications": "Obavesti me kada @{name} objavi",
  "account.endorse": "Istakni na profilu",
  "account.featured.accounts": "Profili",
  "account.filters.all": "Sve aktivnosti",
  "account.filters.posts_only": "Objave",
  "account.filters.posts_replies": "Objave i odgovori",
  "account.filters.replies_toggle": "Prikaži odgovore",
  "account.follow": "Prati",
  "account.follow_back": "Uzvrati praćenje",
  "account.follow_back_short": "Uzvrati praćenje",
  "account.follow_request": "Zahtevaj praćenje",
  "account.follow_request_cancel": "Poništi zahtev",
  "account.follow_request_cancel_short": "Poništi",
  "account.follow_request_short": "Zahtevaj",
  "account.followers": "Pratioci",
  "account.followers.empty": "Još uvek niko ne prati ovog korisnika.",
  "account.followers_counter": "{count, plural, one {{counter} pratilac} few {{counter} pratioca} other {{counter} pratilaca}}",
  "account.followers_you_know_counter": "{counter} koje ti poznaješ",
  "account.following": "Prati",
  "account.following_counter": "{count, plural, one {{counter} prati} few {{counter} prati} other {{counter} prati}}",
  "account.follows.empty": "Ovaj korisnik još uvek nikog ne prati.",
  "account.follows_you": "Prati te",
  "account.go_to_profile": "Idi na profil",
  "account.hide_reblogs": "Sakrij podržavanja @{name}",
  "account.in_memoriam": "U znak sećanja na.",
  "account.joined_short": "Datum pridruživanja",
  "account.languages": "Promeni pretplaćene jezike",
  "account.link_verified_on": "Vlasništvo nad ovom vezom je provereno {date}",
  "account.locked_info": "Status privatnosti ovog naloga je podešen na „zaključano”. Vlasnik ručno pregleda ko ga može pratiti.",
  "account.media": "Multimedija",
  "account.mention": "Pomeni korisnika @{name}",
  "account.menu.add_to_list": "Dodaj u listu",
  "account.menu.block": "Blokiraj nalog",
  "account.menu.block_domain": "Blokiraj {domain}",
  "account.menu.copy": "Kopiraj link",
  "account.menu.remove_follower": "Ukloni pratioca",
  "account.menu.report": "Prijavi nalog",
  "account.moved_to": "Korisnik {name} je naznačio da je njegov novi nalog sada:",
  "account.mute": "Ignoriši korisnika @{name}",
  "account.mute_notifications_short": "Isključi obaveštenja",
  "account.mute_short": "Isključi",
  "account.muted": "Ignorisan",
  "account.no_bio": "Nema opisa.",
  "account.open_original_page": "Otvori originalnu stranicu",
  "account.posts": "Objave",
  "account.report": "Prijavi @{name}",
  "account.requested_follow": "{name} je zatražio da vas prati",
  "account.share": "Podeli profil korisnika @{name}",
  "account.show_reblogs": "Prikaži podržavanja od korisnika @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} objava} few {{counter} objave} other {{counter} objava}}",
  "account.unblock": "Odblokiraj korisnika @{name}",
  "account.unblock_domain": "Odblokiraj domen {domain}",
  "account.unblock_short": "Odblokiraj",
  "account.unendorse": "Ne ističi na profilu",
  "account.unfollow": "Otprati",
  "account.unmute": "Ne ignoriši @{name}",
  "account.unmute_notifications_short": "Uključi obaveštenja",
  "account.unmute_short": "Ne ignoriši",
  "account_note.placeholder": "Kliknite da dodate napomenu",
  "admin.dashboard.daily_retention": "Stopa zadržavanja korisnika po danima nakon registracije",
  "admin.dashboard.monthly_retention": "Stopa zadržavanja korisnika po mesecima nakon registracije",
  "admin.dashboard.retention.average": "Prosek",
  "admin.dashboard.retention.cohort": "Mesec pristupanja",
  "admin.dashboard.retention.cohort_size": "Novi korisnici",
  "admin.impact_report.instance_accounts": "Profili naloga koje bi ovo izbrisalo",
  "admin.impact_report.instance_followers": "Pratioci koje bi naši korisnici izgubili",
  "admin.impact_report.instance_follows": "Pratioci koje bi njihovi korisnici izgubili",
  "admin.impact_report.title": "Rezime uticaja",
  "alert.rate_limited.message": "Pokušajte ponovo posle {retry_time, time, medium}.",
  "alert.rate_limited.title": "Ograničenje zahteva",
  "alert.unexpected.message": "Došlo je do neočekivane greške.",
  "alert.unexpected.title": "Ups!",
  "announcement.announcement": "Najava",
  "attachments_list.unprocessed": "(neobrađeno)",
  "audio.hide": "Sakrij audio",
  "block_modal.remote_users_caveat": "Zamolićemo server {domain} da poštuje vašu odluku. Međutim, usklađenost nije zagarantovana jer neki serveri mogu drugačije da obrađuju blokove. Javne objave mogu i dalje biti vidljive korisnicima koji nisu prijavljeni.",
  "block_modal.show_less": "Prikaži manje",
  "block_modal.show_more": "Prikaži više",
  "block_modal.they_will_know": "Mogu da vide da su blokirani.",
  "block_modal.title": "Blokirati korisnika?",
  "boost_modal.combo": "Možete pritisnuti {combo} da preskočite ovo sledeći put",
  "bundle_column_error.copy_stacktrace": "Kopiraj izveštaj o grešci",
  "bundle_column_error.error.body": "Nije moguće prikazati traženu stranicu. Razlog može biti greška u našem kodu ili problem sa kompatibilnošću pretraživača.",
  "bundle_column_error.error.title": "O, ne!",
  "bundle_column_error.network.body": "Došlo je do greške pri pokušaju učitavanja ove stranice. Razlog može biti trenutni problem sa vašom internet vezom ili sa ovim serverom.",
  "bundle_column_error.network.title": "Greška na mreži",
  "bundle_column_error.retry": "Pokušajte ponovo",
  "bundle_column_error.return": "Idi na početak",
  "bundle_column_error.routing.body": "Nije moguće pronaći traženu stranicu. Da li ste sigurni da je URL u adresnom polju ispravan?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Zatvori",
  "bundle_modal_error.retry": "Pokušajte ponovo",
  "closed_registrations.other_server_instructions": "Pošto je Mastodon decentralizovan, možete napraviti nalog na drugom serveru ali i dalje komunicirati sa ovim.",
  "closed_registrations_modal.description": "Kreiranje naloga na {domain} trenutno nije moguće, ali imajte u vidu da vam ne treba nalog zasebno na {domain} da biste koristili Mastodon.",
  "closed_registrations_modal.find_another_server": "Pronađite drugi server",
  "closed_registrations_modal.preamble": "Mastodon je decentralizovan, tako da bez obzira gde kreirate svoj nalog, moći ćete da pratite i komunicirate sa bilo kim na ovom serveru. Možete čak i sami da ga hostujete!",
  "closed_registrations_modal.title": "Registracija za Mastodon",
  "column.about": "Osnovni podaci",
  "column.blocks": "Blokirani korisnici",
  "column.bookmarks": "Obeleživači",
  "column.community": "Lokalna vremenska linija",
  "column.direct": "Privatna pominjanja",
  "column.directory": "Pregledaj profile",
  "column.domain_blocks": "Blokirani domeni",
  "column.favourites": "Omiljeno",
  "column.firehose": "Izvori uživo",
  "column.follow_requests": "Zahtevi za praćenje",
  "column.home": "Početna",
  "column.lists": "Liste",
  "column.mutes": "Ignorisani korisnici",
  "column.notifications": "Obaveštenja",
  "column.pins": "Zakačene objave",
  "column.public": "Združena vremenska linija",
  "column_back_button.label": "Nazad",
  "column_header.hide_settings": "Sakrij podešavanja",
  "column_header.moveLeft_settings": "Premesti kolonu ulevo",
  "column_header.moveRight_settings": "Premesti kolonu udesno",
  "column_header.pin": "Zakači",
  "column_header.show_settings": "Prikaži podešavanja",
  "column_header.unpin": "Otkači",
  "community.column_settings.local_only": "Samo lokalno",
  "community.column_settings.media_only": "Samo multimedija",
  "community.column_settings.remote_only": "Samo udaljeno",
  "compose.language.change": "Promeni jezik",
  "compose.language.search": "Pretraga jezika...",
  "compose.published.body": "Objava objavljena.",
  "compose.published.open": "Otvori",
  "compose.saved.body": "Objava je sačuvana.",
  "compose_form.direct_message_warning_learn_more": "Saznajte više",
  "compose_form.encryption_warning": "Objave na Mastodon-u nisu potpuno šifrovane. Nemojte deliti nikakve osetljive informacije preko Mastodon-a.",
  "compose_form.hashtag_warning": "Ova objava neće biti navedena ni pod jednom heš oznakom jer nije javna. Samo javne objave se mogu pretraživati po heš oznakama.",
  "compose_form.lock_disclaimer": "Vaš nalog nije {locked}. Svako može da vas prati i da vidi vaše objave namenjene samo za vaše pratioce.",
  "compose_form.lock_disclaimer.lock": "zaključan",
  "compose_form.placeholder": "O čemu razmišljate?",
  "compose_form.poll.duration": "Trajanje ankete",
  "compose_form.poll.multiple": "Višestruki izbor",
  "compose_form.poll.option_placeholder": "Opcija {number}",
  "compose_form.poll.switch_to_multiple": "Promenite anketu da biste omogućili više izbora",
  "compose_form.poll.switch_to_single": "Promenite anketu da biste omogućili jedan izbor",
  "compose_form.poll.type": "Stil",
  "compose_form.publish": "Objavi",
  "compose_form.reply": "Odgovori",
  "compose_form.save_changes": "Ažuriraj",
  "compose_form.spoiler.marked": "Ukloni upozorenje o sadržaju",
  "compose_form.spoiler.unmarked": "Dodaj upozorenje o sadržaju",
  "compose_form.spoiler_placeholder": "Upozorenje o sadržaju (opciono)",
  "confirmation_modal.cancel": "Otkaži",
  "confirmations.block.confirm": "Blokiraj",
  "confirmations.delete.confirm": "Izbriši",
  "confirmations.delete.message": "Da li ste sigurni da želite da izbrišete ovu objavu?",
  "confirmations.delete_list.confirm": "Izbriši",
  "confirmations.delete_list.message": "Da li ste sigurni da želite da trajno izbrišete ovu listu?",
  "confirmations.discard_edit_media.confirm": "Odbaci",
  "confirmations.discard_edit_media.message": "Imate nesačuvane promene u opisu ili pregledu medija, da li ipak hoćete da ih odbacite?",
  "confirmations.logout.confirm": "Odjava",
  "confirmations.logout.message": "Da li ste sigurni da želite da se odjavite?",
  "confirmations.mute.confirm": "Ignoriši",
  "confirmations.redraft.confirm": "Izbriši i prepravi",
  "confirmations.redraft.message": "Da li ste sigurni da želite da izbrišete ovu objavu i da je prepravite? Podržavanja i oznake kao omiljenih će biti izgubljeni, a odgovori će ostati bez originalne objave.",
  "confirmations.unfollow.confirm": "Otprati",
  "conversation.delete": "Izbriši razgovor",
  "conversation.mark_as_read": "Označi kao pročitano",
  "conversation.open": "Prikaži razgovor",
  "conversation.with": "Sa {names}",
  "copy_icon_button.copied": "Kopirano",
  "copypaste.copied": "Kopirano",
  "copypaste.copy_to_clipboard": "Kopiraj",
  "directory.federated": "Sa znanog fediverzuma",
  "directory.local": "Samo sa {domain}",
  "directory.new_arrivals": "Novopridošli",
  "directory.recently_active": "Nedavno aktivni",
  "disabled_account_banner.account_settings": "Podešavanja naloga",
  "disabled_account_banner.text": "Vaš nalog {disabledAccount} je trenutno onemogućen.",
  "dismissable_banner.community_timeline": "Ovo su najnovije javne objave ljudi čije naloge hostuje {domain}.",
  "dismissable_banner.dismiss": "Odbaci",
  "domain_block_modal.block": "Blokiraj server",
  "domain_block_modal.block_account_instead": "Umesto toga, blokiraj @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Ljudi sa ovog servera mogu da imaju interakciju sa vašim starim objavama.",
  "domain_block_modal.they_cant_follow": "Niko sa ovog servera ne može da vas prati.",
  "domain_block_modal.they_wont_know": "Neće znati da su blokirani.",
  "domain_block_modal.title": "Blokirati domen?",
  "domain_block_modal.you_wont_see_posts": "Nećete videti objave ili obaveštenja korisnika na ovom serveru.",
  "domain_pill.activitypub_lets_connect": "Omogućuje vam da se povežete i komunicirate sa ljudima ne samo na Mastodon-u, već i u različitim društvenim aplikacijama.",
  "domain_pill.activitypub_like_language": "ActivityPub je kao jezik kojim Mastodon govori sa drugim društvenim mrežama.",
  "domain_pill.server": "Server",
  "domain_pill.their_handle": "Njegov regulator:",
  "domain_pill.their_server": "Njihov digitalni dom, gde žive sve njihove objave.",
  "domain_pill.their_username": "Njihov jedinstveni identifikator na njihovom serveru. Moguće je pronaći korisnike sa istim korisničkim imenom na različitim serverima.",
  "domain_pill.username": "Korisničko ime",
  "domain_pill.whats_in_a_handle": "Šta je regulator?",
  "domain_pill.who_they_are": "Pošto regulatori govore ko je neko i gde se nalazi, možete da komunicirate sa ljudima širom društvenog veba na <button>platformama koje pokreće ActivityPub</button>.",
  "domain_pill.who_you_are": "Pošto vaši regulatori govori ko ste i gde ste, ljudi mogu da komuniciraju sa vama širom društvenog veba na <button>platformama koje pokreće ActivityPub</button>.",
  "domain_pill.your_handle": "Vaš regulator:",
  "domain_pill.your_server": "Vaš digitalni dom, gde žive sve vaše objave. Ne sviđa vam se ovaj? Prenesite servere u bilo koje vreme i dovedite i svoje pratioce.",
  "domain_pill.your_username": "Njihov jedinstveni identifikator na njihovom serveru. Moguće je pronaći korisnike sa istim korisničkim imenom na različitim serverima.",
  "embed.instructions": "Ugradite ovu objavu na svoj veb sajt kopiranjem koda ispod.",
  "embed.preview": "Evo kako će to izgledati:",
  "emoji_button.activity": "Aktivnosti",
  "emoji_button.clear": "Obriši",
  "emoji_button.custom": "Prilagođeno",
  "emoji_button.flags": "Zastavice",
  "emoji_button.food": "Hrana i piće",
  "emoji_button.label": "Ubaci emodži",
  "emoji_button.nature": "Priroda",
  "emoji_button.not_found": "Nema pronađih odgovarajućih emodžija",
  "emoji_button.objects": "Objekti",
  "emoji_button.people": "Ljudi",
  "emoji_button.recent": "Najčešće korišćeni",
  "emoji_button.search": "Pretraga...",
  "emoji_button.search_results": "Rezultati pretrage",
  "emoji_button.symbols": "Simboli",
  "emoji_button.travel": "Putovanja i mesta",
  "empty_column.account_hides_collections": "Ovaj korisnik je odlučio da ove informacije ne učini dostupnim",
  "empty_column.account_suspended": "Nalog je suspendovan",
  "empty_column.account_timeline": "Nema objava ovde!",
  "empty_column.account_unavailable": "Profil je nedostupan",
  "empty_column.blocks": "Još uvek niste blokirali nijednog korisnika.",
  "empty_column.bookmarked_statuses": "Još uvek nemate objava dodanih u obeleživače. Kada dodate neku, pojaviće se ovde.",
  "empty_column.community": "Lokalna vremenska linija je prazna. Napišite nešto javno da započnete!",
  "empty_column.direct": "Još uvek nemate privatnih pominjanja. Kada pošaljete ili primite jedno, ono će se pojaviti ovde.",
  "empty_column.domain_blocks": "Još uvek nema blokiranih domena.",
  "empty_column.explore_statuses": "Trenutno ništa nije u trendu. Proverite ponovo kasnije!",
  "empty_column.favourited_statuses": "Još uvek nemate objava označenih kao omiljene. Kada označite neku, pojaviće se ovde.",
  "empty_column.favourites": "Niko još nije označio ovu objavu kao omiljenu. Kada neko to uradi, pojaviće se ovde.",
  "empty_column.follow_requests": "Još uvek nemate nijedan zahtev za praćenje. Kada primite zahtev, on će se pojaviti ovde.",
  "empty_column.followed_tags": "Još uvek niste zapratili nijednu heš oznaku. Kada to uradite, one će se pojaviti ovde.",
  "empty_column.hashtag": "Još uvek nema ničega u ovoj heš oznaci.",
  "empty_column.home": "Vaša početna vremenska linija je prazna! Pratite više ljudi da biste je popunili.",
  "empty_column.list": "U ovoj listi još nema ničega. Kada članovi ove liste objave nešto novo, pojaviće se ovde.",
  "empty_column.mutes": "Još uvek ne ignorišete nijednog korisnika.",
  "empty_column.notification_requests": "Sve je čisto! Ovde nema ničega. Kada dobijete nova obaveštenja, ona će se pojaviti ovde u skladu sa vašim podešavanjima.",
  "empty_column.notifications": "Još uvek nemate nikakva obaveštenja. Kada drugi ljudi budu u interakciji sa vama, videćete to ovde.",
  "empty_column.public": "Ovde nema ničega! Napišite nešto javno ili ručno pratite korisnike sa drugih servera da biste ovo popunili",
  "error.unexpected_crash.explanation": "Zbog greške u našem kodu ili problema sa kompatibilnošću pregledača, ova stranica se nije mogla pravilno prikazati.",
  "error.unexpected_crash.explanation_addons": "Ova stranica se nije mogla pravilno prikazati. Ovu grešku verovatno uzrokuju dodaci pregledača ili alati za automatsko prevođenje.",
  "error.unexpected_crash.next_steps": "Pokušajte da osvežite stranicu. Ako to ne pomogne, možda ćete i dalje moći da koristite Mastodon putem drugog pregledača ili matične aplikacije.",
  "error.unexpected_crash.next_steps_addons": "Pokušajte da ih onemogućite i osvežite stranicu. Ako to ne pomogne, možete da nastavite da koristite Mastodon korišćenjem drugog pregledača ili matične aplikacije.",
  "errors.unexpected_crash.copy_stacktrace": "Kopiraj „stacktrace” u klipbord",
  "errors.unexpected_crash.report_issue": "Prijavi problem",
  "explore.suggested_follows": "Ljudi",
  "explore.trending_links": "Vesti",
  "explore.trending_statuses": "Objave",
  "explore.trending_tags": "Heš oznake",
  "filter_modal.added.context_mismatch_explanation": "Ova kategorija filtera se ne odnosi na kontekst u kojem ste pristupili ovoj objavi. Ako želite da se objava filtrira i u ovom kontekstu, morate urediti filter.",
  "filter_modal.added.context_mismatch_title": "Kontekst se ne podudara!",
  "filter_modal.added.expired_explanation": "Ova kategorija filtera je istekla, morate promeniti datum isteka da bi se primenjivala.",
  "filter_modal.added.expired_title": "Filter je istekao!",
  "filter_modal.added.review_and_configure": "Za pregled i dalju konfiguraciju ove kategorije filtera, idite na {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Podešavanja filtera",
  "filter_modal.added.settings_link": "stranica podešavanja",
  "filter_modal.added.short_explanation": "Ova objava je dodata u sledeću filter kategoriju: {title}.",
  "filter_modal.added.title": "Filter je dodat!",
  "filter_modal.select_filter.context_mismatch": "ne odnosi se na ovaj kontekst",
  "filter_modal.select_filter.expired": "isteklo",
  "filter_modal.select_filter.prompt_new": "Nova kategorija: {name}",
  "filter_modal.select_filter.search": "Pretraži ili kreiraj",
  "filter_modal.select_filter.subtitle": "Koristite postojeću kategoriju ili kreirajte novu",
  "filter_modal.select_filter.title": "Filtriraj ovu objavu",
  "filter_modal.title.status": "Filtriraj objavu",
  "filtered_notifications_banner.title": "Filtrirana obaveštenja",
  "firehose.all": "Sve",
  "firehose.local": "Ovaj server",
  "firehose.remote": "Ostali serveri",
  "follow_request.authorize": "Odobri",
  "follow_request.reject": "Odbij",
  "follow_requests.unlocked_explanation": "Iako vaš nalog nije zaključan, osoblje {domain} smatra da biste možda želeli da ručno pregledate zahteve za praćenje sa ovih naloga.",
  "follow_suggestions.curated_suggestion": "Izbor osoblja",
  "follow_suggestions.dismiss": "Ne prikazuj ponovo",
  "follow_suggestions.featured_longer": "Ručno odabrao tim {domain}",
  "follow_suggestions.friends_of_friends_longer": "Popularno među ljudima koje pratite",
  "follow_suggestions.hints.featured": "Ovaj profil je ručno izabrao tim {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Ovaj profil je popularan među ljudima koje pratite.",
  "follow_suggestions.hints.most_followed": "Ovaj profil je jedan od najpraćenijih na {domain}.",
  "follow_suggestions.hints.most_interactions": "Ovaj profil je nedavno dobio veliku pažnju na {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Ovaj profil je sličan profilima koje ste nedavno zapratili.",
  "follow_suggestions.personalized_suggestion": "Personalizovani predlog",
  "follow_suggestions.popular_suggestion": "Popularni predlog",
  "follow_suggestions.popular_suggestion_longer": "Popularno na {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Slično profilima koje ste nedavno zapratili",
  "follow_suggestions.view_all": "Prikaži sve",
  "follow_suggestions.who_to_follow": "Koga pratiti",
  "followed_tags": "Praćene heš oznake",
  "footer.about": "Osnovni podaci",
  "footer.directory": "Direktorijum profila",
  "footer.get_app": "Preuzmite aplikaciju",
  "footer.keyboard_shortcuts": "Tasterske prečice",
  "footer.privacy_policy": "Politika privatnosti",
  "footer.source_code": "Prikaži izvorni kod",
  "footer.status": "Status",
  "generic.saved": "Sačuvano",
  "getting_started.heading": "Prvi koraci",
  "hashtag.column_header.tag_mode.all": "i {additional}",
  "hashtag.column_header.tag_mode.any": "ili {additional}",
  "hashtag.column_header.tag_mode.none": "bez {additional}",
  "hashtag.column_settings.select.no_options_message": "Nisu pronađeni predlozi",
  "hashtag.column_settings.select.placeholder": "Unesite heš oznake…",
  "hashtag.column_settings.tag_mode.all": "Sve",
  "hashtag.column_settings.tag_mode.any": "Bilo koje od ovih",
  "hashtag.column_settings.tag_mode.none": "Nijedan od ovih",
  "hashtag.column_settings.tag_toggle": "Uključi dodatne oznake za ovu kolonu",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} učesnik} few {{counter} učesnika} other {{counter} učesnika}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} objava} few {{counter} objave} other {{counter} objava}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} objava} few {{counter} objave} other {{counter} objava}} danas",
  "hashtag.follow": "Zaprati heš oznaku",
  "hashtag.unfollow": "Otprati heš oznaku",
  "hashtags.and_other": "…i {count, plural, one {još #} few {još #}other {još #}}",
  "home.column_settings.show_reblogs": "Prikaži podržavanja",
  "home.column_settings.show_replies": "Prikaži odgovore",
  "home.hide_announcements": "Sakrij najave",
  "home.pending_critical_update.body": "Ažurirajte svoj Mastodon server što je pre moguće!",
  "home.pending_critical_update.link": "Pogledajte ažuriranja",
  "home.pending_critical_update.title": "Dostupno je kritično bezbednosno ažuriranje!",
  "home.show_announcements": "Prijaži najave",
  "interaction_modal.on_another_server": "Na drugom serveru",
  "interaction_modal.on_this_server": "Na ovom serveru",
  "intervals.full.days": "{number, plural, one {# dan} few {# dana} other {# dana}}",
  "intervals.full.hours": "{number, plural, one {# sat} few {# sata} other {# sati}}",
  "intervals.full.minutes": "{number, plural, one {# minut} few {# minuta} other {# minuta}}",
  "keyboard_shortcuts.back": "Idi nazad",
  "keyboard_shortcuts.blocked": "Otvori listu blokiranih korisnika",
  "keyboard_shortcuts.boost": "Podrži objavu",
  "keyboard_shortcuts.column": "Fokusiraj kolonu",
  "keyboard_shortcuts.compose": "Fokusiraj polje za sastavljanje objave",
  "keyboard_shortcuts.description": "Opis",
  "keyboard_shortcuts.down": "Premesti nadole u listi",
  "keyboard_shortcuts.enter": "Otvori objavu",
  "keyboard_shortcuts.favourite": "Označi objavu kao omiljenu",
  "keyboard_shortcuts.favourites": "Otvori listu omiljenih",
  "keyboard_shortcuts.federated": "Otvori združenu vremensku liniju",
  "keyboard_shortcuts.heading": "Tasterske prečice",
  "keyboard_shortcuts.home": "Otvori početnu vremensku liniju",
  "keyboard_shortcuts.hotkey": "Prečica",
  "keyboard_shortcuts.legend": "Prikaži ovu legendu",
  "keyboard_shortcuts.local": "Otvori lokalnu vremensku liniju",
  "keyboard_shortcuts.mention": "Pomeni autora",
  "keyboard_shortcuts.muted": "Otvori listu ignorisanih korisnika",
  "keyboard_shortcuts.my_profile": "Otvorite svoj profil",
  "keyboard_shortcuts.notifications": "Otvori kolonu obaveštenja",
  "keyboard_shortcuts.open_media": "Otvori multimediju",
  "keyboard_shortcuts.pinned": "Otvori listu zakačenih objava",
  "keyboard_shortcuts.profile": "Otvori profil autora",
  "keyboard_shortcuts.reply": "Odgovori na objavu",
  "keyboard_shortcuts.requests": "Otvori listu zahteva za praćenje",
  "keyboard_shortcuts.search": "Fokusiraj traku pretrage",
  "keyboard_shortcuts.spoilers": "Prikaži/sakrij polje teksta upozorenja o sadržaju (CW)",
  "keyboard_shortcuts.start": "Otvori kolonu „prvi koraci”",
  "keyboard_shortcuts.toggle_hidden": "Prikaži/sakrij tekst iza upozorenja",
  "keyboard_shortcuts.toggle_sensitivity": "Prikaži/sakrij multimediju",
  "keyboard_shortcuts.toot": "Započni novu objavu",
  "keyboard_shortcuts.unfocus": "Ukloni fokus sa polja za unos teksta/pretrage",
  "keyboard_shortcuts.up": "Premesti nagore u listi",
  "lightbox.close": "Zatvori",
  "lightbox.next": "Sledeće",
  "lightbox.previous": "Prethodno",
  "limited_account_hint.action": "Ipak prikaži profil",
  "limited_account_hint.title": "Ovaj profil su sakrili moderatori {domain}.",
  "link_preview.author": "Po {name}",
  "link_preview.more_from_author": "Više od {name}",
  "link_preview.shares": "{count, plural, one {{counter} objava} few {{counter} objave} other {{counter} objava}}",
  "lists.delete": "Izbriši listu",
  "lists.edit": "Uredi listu",
  "lists.replies_policy.followed": "Svakom praćenom korisniku",
  "lists.replies_policy.list": "Članovima liste",
  "lists.replies_policy.none": "Nikome",
  "load_pending": "{count, plural, one {# nova stavka} few {# nove stavke} other {# novih stavki}}",
  "loading_indicator.label": "Učitavanje…",
  "moved_to_account_banner.text": "Vaš nalog {disabledAccount} je trenutno onemogućen jer ste prešli na {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Sakrij iz obaveštenja",
  "mute_modal.hide_options": "Sakrij opcije",
  "mute_modal.indefinite": "Dok ih ne uklonim iz ignorisanih",
  "mute_modal.show_options": "Prikaži opcije",
  "mute_modal.they_can_mention_and_follow": "Mogu da vas pominju i prate, ali ih nećete videti.",
  "mute_modal.they_wont_know": "Neće znati da su ignorisani.",
  "mute_modal.title": "Ignorisati korisnika?",
  "mute_modal.you_wont_see_mentions": "Nećete videti objave koje ga pominju.",
  "mute_modal.you_wont_see_posts": "I dalje može da vidi vaše objave, ali vi nećete videti njegove.",
  "navigation_bar.about": "Osnovni podaci",
  "navigation_bar.advanced_interface": "Otvori u naprednom veb okruženju",
  "navigation_bar.blocks": "Blokirani korisnici",
  "navigation_bar.bookmarks": "Obeleživači",
  "navigation_bar.direct": "Privatna pominjanja",
  "navigation_bar.domain_blocks": "Blokirani domeni",
  "navigation_bar.favourites": "Omiljeno",
  "navigation_bar.filters": "Ignorisane reči",
  "navigation_bar.follow_requests": "Zahtevi za praćenje",
  "navigation_bar.followed_tags": "Praćene heš oznake",
  "navigation_bar.follows_and_followers": "Praćenja i pratioci",
  "navigation_bar.lists": "Liste",
  "navigation_bar.logout": "Odjava",
  "navigation_bar.mutes": "Ignorisani korisnici",
  "navigation_bar.opened_in_classic_interface": "Objave, nalozi i druge specifične stranice se podrazumevano otvaraju u klasičnom veb okruženju.",
  "navigation_bar.preferences": "Podešavanja",
  "navigation_bar.search": "Pretraga",
  "not_signed_in_indicator.not_signed_in": "Morate da se prijavite da biste pristupili ovom resursu.",
  "notification.admin.report": "{name} je prijavio/-la {target}",
  "notification.admin.sign_up": "{name} se registrovao/-la",
  "notification.favourite": "{name} je označio vašu objavu kao omiljenu",
  "notification.follow": "{name} vas je zapratio",
  "notification.follow_request": "{name} je zatražio da vas prati",
  "notification.moderation-warning.learn_more": "Saznajte više",
  "notification.moderation_warning": "Dobili ste moderatorsko upozorenje",
  "notification.moderation_warning.action_delete_statuses": "Neke od vaših objava su uklonjene.",
  "notification.moderation_warning.action_disable": "Vaš nalog je onemogućen.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Neke od vaših objava su obeležene kao osetljive.",
  "notification.moderation_warning.action_none": "Vaš nalog je dobio moderatorsko upozorenje.",
  "notification.moderation_warning.action_sensitive": "Vaše objave će ubuduće biti označene kao osetljive.",
  "notification.moderation_warning.action_silence": "Vaš nalog je ograničen.",
  "notification.moderation_warning.action_suspend": "Vaš nalog je suspendovan.",
  "notification.own_poll": "Vaša anketa je završena",
  "notification.reblog": "{name} je podržao vašu objavu",
  "notification.relationships_severance_event": "Izgubljena veza sa {name}",
  "notification.relationships_severance_event.account_suspension": "Administrator sa {from} je suspendovao {target}, što znači da više ne možete da primate ažuriranja od njih niti da komunicirate sa njima.",
  "notification.relationships_severance_event.domain_block": "Administrator sa {from} je blokirao {target}, uključujući vaše pratioce: {followersCount} i {followingCount, plural, one {# nalog} few {# naloga} other {# naloga}} koje pratite.",
  "notification.relationships_severance_event.learn_more": "Saznajte više",
  "notification.relationships_severance_event.user_domain_block": "Blokirači ste {target}, uključujući vaše pratioce: {followersCount} i {followingCount, plural, one {# nalog} few {# naloga} other {# naloga}} koje pratite.",
  "notification.status": "{name} je upravo objavio",
  "notification.update": "{name} je uredio objavu",
  "notification_requests.accept": "Prihvati",
  "notification_requests.dismiss": "Odbaci",
  "notification_requests.notifications_from": "Obaveštenja od {name}",
  "notification_requests.title": "Filtrirana obaveštenja",
  "notifications.clear": "Obriši obaveštenja",
  "notifications.clear_confirmation": "Da li ste sigurni da želite trajno da obrišete sva vaša obaveštenja?",
  "notifications.column_settings.admin.report": "Nove prijave:",
  "notifications.column_settings.admin.sign_up": "Nove ragistracije:",
  "notifications.column_settings.alert": "Obaveštenja na radnoj površini",
  "notifications.column_settings.favourite": "Omiljeno:",
  "notifications.column_settings.filter_bar.advanced": "Prikaži sve kategorije",
  "notifications.column_settings.filter_bar.category": "Traka za brzo filtriranje",
  "notifications.column_settings.follow": "Novi pratioci:",
  "notifications.column_settings.follow_request": "Novi zahtevi za praćenje:",
  "notifications.column_settings.mention": "Pominjanja:",
  "notifications.column_settings.poll": "Rezultati ankete:",
  "notifications.column_settings.push": "Prosleđena obaveštenja",
  "notifications.column_settings.reblog": "Podržavanja:",
  "notifications.column_settings.show": "Prikaži u koloni",
  "notifications.column_settings.sound": "Reprodukuj zvuk",
  "notifications.column_settings.status": "Nove objave:",
  "notifications.column_settings.unread_notifications.category": "Nepročitana obaveštenja",
  "notifications.column_settings.unread_notifications.highlight": "Istakni nepročitana obaveštenja",
  "notifications.column_settings.update": "Uređivanja:",
  "notifications.filter.all": "Sve",
  "notifications.filter.boosts": "Podržavanja",
  "notifications.filter.favourites": "Omiljeno",
  "notifications.filter.follows": "Praćenja",
  "notifications.filter.mentions": "Pominjanja",
  "notifications.filter.polls": "Rezultati ankete",
  "notifications.filter.statuses": "Ažuriranja od ljudi koje pratite",
  "notifications.grant_permission": "Odobri dozvolu.",
  "notifications.group": "{count} obaveštenja",
  "notifications.mark_as_read": "Označi svako obaveštenje kao pročitano",
  "notifications.permission_denied": "Obaveštenja na radnoj površini nisu dostupna zbog prethodno odbijenog zahteva za dozvolu pregledača",
  "notifications.permission_denied_alert": "Obaveštenja na radnoj površini ne mogu biti omogućena, jer je dozvola pregledača ranije bila odbijena",
  "notifications.permission_required": "Obaveštenja na radnoj površini nisu dostupna jer potrebna dozvola nije dodeljena.",
  "notifications.policy.filter_new_accounts.hint": "Kreirano {days, plural, one {u poslednjeg # dana} few {u poslednja # dana} other {u poslednjih # dana}}",
  "notifications.policy.filter_new_accounts_title": "Novi nalozi",
  "notifications.policy.filter_not_followers_hint": "Uključujući ljude koji su vas pratili manje od {days, plural, one {# dana} few {# dana} other {# dana}}",
  "notifications.policy.filter_not_followers_title": "Ljudi koji vas ne prate",
  "notifications.policy.filter_not_following_hint": "Dok ih ručno ne odobrite",
  "notifications.policy.filter_not_following_title": "Ljudi koje ne pratite",
  "notifications.policy.filter_private_mentions_hint": "Filtrirano osim ako je odgovor na vaše pominjanje ili ako pratite pošiljaoca",
  "notifications.policy.filter_private_mentions_title": "Neželjena privatna pominjanja",
  "notifications_permission_banner.enable": "Omogućiti obaveštenja na radnoj površini",
  "notifications_permission_banner.how_to_control": "Da biste primali obaveštenja kada Mastodon nije otvoren, omogućite obaveštenja na radnoj površini. Kada su obaveštenja na radnoj površini omogućena vrste interakcija koje ona generišu mogu se podešavati pomoću dugmeta {icon}.",
  "notifications_permission_banner.title": "Nikada ništa ne propustite",
  "onboarding.follows.empty": "Nažalost, trenutno se ne mogu prikazati rezultati. Možete pokušati sa korišćenjem pretrage ili pregledanjem stranice za istraživanje da biste pronašli ljude koje ćete pratiti ili pokušajte ponovo kasnije.",
  "onboarding.profile.discoverable": "Neka se moj profil može otkriti drugima",
  "onboarding.profile.discoverable_hint": "Kada omogućite mogućnost otkrivanja na Mastodon-u, vaše objave se mogu pojaviti u rezultatima pretrage i u trendu, a vaš profil može biti predložen ljudima sa sličnim interesovanjima.",
  "onboarding.profile.display_name": "Ime za prikaz",
  "onboarding.profile.display_name_hint": "Vaše puno ime ili nadimak…",
  "onboarding.profile.note": "Biografija",
  "onboarding.profile.note_hint": "Možete da @pomenete druge ljude ili #heš oznake…",
  "onboarding.profile.title": "Podešavanje profila",
  "onboarding.profile.upload_avatar": "Otpremi sliku profila",
  "onboarding.profile.upload_header": "Otpremi zaglavlje profila",
  "password_confirmation.exceeds_maxlength": "Potvrda lozinke premašuje maksimalnu dužinu lozinke",
  "password_confirmation.mismatching": "Potvrda lozinke se ne podudara",
  "picture_in_picture.restore": "Vrati nazad",
  "poll.closed": "Zatvoreno",
  "poll.refresh": "Osveži",
  "poll.reveal": "Vidi rezultate",
  "poll.total_people": "{count, plural, one {# osoba} few {# osobe} other {# osoba}}",
  "poll.total_votes": "{count, plural, one {# glas} few {# glasa} other {# glasova}}",
  "poll.vote": "Glasajte",
  "poll.voted": "Glasali ste za ovaj odgovor",
  "poll.votes": "{votes, plural, one {# glas} few {# glasa} other {# glasova}}",
  "poll_button.add_poll": "Dodaj anketu",
  "poll_button.remove_poll": "Ukloni anketu",
  "privacy.change": "Promeni privatnost objave",
  "privacy.direct.long": "Svi pomenuti u objavi",
  "privacy.private.long": "Samo vaši pratioci",
  "privacy.private.short": "Pratioci",
  "privacy.public.long": "Bilo ko na Mastodon-u i van njega",
  "privacy.public.short": "Javno",
  "privacy.unlisted.additional": "Ovo se ponaša potpuno kao javno, osim što se objava neće pojavljivati u izvorima uživo ili heš oznakama, istraživanjima ili pretrazi Mastodon-a, čak i ako ste uključeni u celom nalogu.",
  "privacy.unlisted.short": "Tiha javnost",
  "privacy_policy.last_updated": "Poslednje ažuriranje {date}",
  "privacy_policy.title": "Politika privatnosti",
  "recommended": "Preporučeno",
  "refresh": "Osveži",
  "relative_time.days": "{number} dan.",
  "relative_time.full.days": "Pre {number, plural, one {# dan} few {# dana} other {# dana}}",
  "relative_time.full.hours": "pre {number, plural, one {# sat} few {# sata} other {# sati}}",
  "relative_time.full.just_now": "upravo sad",
  "relative_time.full.minutes": "pre {number, plural, one {# minut} few {# minuta} other {# minuta}}",
  "relative_time.full.seconds": "pre {number, plural, one {# sekundu} few {# sekunde} other {# sekundi}}",
  "relative_time.hours": "{number} čas.",
  "relative_time.just_now": "sada",
  "relative_time.minutes": "{number} min.",
  "relative_time.seconds": "{number} sek.",
  "relative_time.today": "danas",
  "reply_indicator.attachments": "{count, plural, one {# prilog} few {# priloga} other {# priloga}}",
  "reply_indicator.cancel": "Otkaži",
  "reply_indicator.poll": "Anketa",
  "report.block": "Blokiraj",
  "report.block_explanation": "Nećete videti objave korisnika. Ni on neće videti Vaše objave niti će moći da Vas prati. Takođe će moći da sazna da je blokiran.",
  "report.categories.legal": "Pravni",
  "report.categories.other": "Ostalo",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Sadržaj krši jedno ili više pravila servera",
  "report.category.subtitle": "Odaberite najpribližnije",
  "report.category.title": "Recite nam šta je problem sa {type}",
  "report.category.title_account": "ovim profilom",
  "report.category.title_status": "objavom",
  "report.close": "Gotovo",
  "report.comment.title": "Da li ima još nešto što biste hteli da nam date do znanja?",
  "report.forward": "Proslediti {target}",
  "report.forward_hint": "Nalog je sa drugog servera. Poslati anonimnu kopiju prijave i tamo?",
  "report.mute": "Ignoriši",
  "report.mute_explanation": "Nećete videti objave korisnika. On će i dalje moći da Vas prati i vidi Vaše objave i neće znati da je ignorisan.",
  "report.next": "Sledeće",
  "report.placeholder": "Dodatni komentari",
  "report.reasons.dislike": "Ne sviđa mi se",
  "report.reasons.dislike_description": "Ovo nije nešto što želite da vidite",
  "report.reasons.legal": "To je protivzakonito",
  "report.reasons.legal_description": "Smatrate da to krši zakon vaše ili zemlje servera",
  "report.reasons.other": "Nešto drugo",
  "report.reasons.other_description": "Problem se ne uklapa u druge kategorije",
  "report.reasons.spam": "Ovo je spam",
  "report.reasons.spam_description": "Zlonamerne veze, lažno angažovanje ili odgovori koji se ponavljaju",
  "report.reasons.violation": "Krši pravila servera",
  "report.reasons.violation_description": "Svesni ste da krši određena pravila",
  "report.rules.subtitle": "Izaberite sva pravila koja su prekršena",
  "report.rules.title": "Koja pravila su prekršena?",
  "report.statuses.subtitle": "Izaberite sve što važi",
  "report.statuses.title": "Ima li bilo kakvih objava koje potkrepljuju ovu prijavu?",
  "report.submit": "Pošalji",
  "report.target": "Prijavljujem {target}",
  "report.thanks.take_action": "Ovo su Vaše opcije da kontrolišete šta vidite na Mastodon-u:",
  "report.thanks.take_action_actionable": "Dok mi pregledamo ovo, možete primeniti sledeće radnje protiv @{name}:",
  "report.thanks.title": "Ne želite da vidite ovo?",
  "report.thanks.title_actionable": "Hvala na prijavi, pregledaćemo je.",
  "report.unfollow": "Otprati @{name}",
  "report.unfollow_explanation": "Pratite ovaj nalog. Da ne biste više videli njegove objave na početnoj stranici, otpratite ga.",
  "report_notification.attached_statuses": "{count, plural, one {{count} objava} few {{count} objave} other {{count} objava}} u prilogu",
  "report_notification.categories.legal": "Legalno",
  "report_notification.categories.other": "Ostalo",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.violation": "Kršenje pravila",
  "report_notification.open": "Otvori prijavu",
  "search.no_recent_searches": "Nema nedavnih pretraga",
  "search.placeholder": "Pretraga",
  "search.quick_action.account_search": "Podudaranje profila {x}",
  "search.quick_action.go_to_account": "Idi na profil {x}",
  "search.quick_action.go_to_hashtag": "Idi na heš oznaku {x}",
  "search.quick_action.open_url": "Otvori URL adresu u Mastodon-u",
  "search.quick_action.status_search": "Podudaranje objava {x}",
  "search.search_or_paste": "Pretražite ili unesite adresu",
  "search_popout.full_text_search_disabled_message": "Nije dostupno na {domain}.",
  "search_popout.full_text_search_logged_out_message": "Dostupno samo kada ste prijavljeni.",
  "search_popout.language_code": "ISO kod jezika",
  "search_popout.options": "Opcije pretrage",
  "search_popout.quick_actions": "Brze radnje",
  "search_popout.recent": "Nedavne pretrage",
  "search_popout.specific_date": "određeni datum",
  "search_popout.user": "korisnik",
  "search_results.accounts": "Profili",
  "search_results.all": "Sve",
  "search_results.hashtags": "Heš oznake",
  "search_results.see_all": "Vidi sve",
  "search_results.statuses": "Objave",
  "server_banner.about_active_users": "Ljudi koji su koristili ovaj server u prethodnih 30 dana (mesečno aktivnih korisnika)",
  "server_banner.active_users": "aktivnih korisnika",
  "server_banner.administered_by": "Administrira:",
  "server_banner.is_one_of_many": "{domain} je jedan od mnogih nezavisnih Mastodon servera koje možete koristiti za učešće u fediverzumu.",
  "server_banner.server_stats": "Statistike servera:",
  "sign_in_banner.create_account": "Napravite nalog",
  "sign_in_banner.follow_anyone": "Pratite bilo koga širom fediverzuma i pogledajte sve hronološkim redom. Nema algoritama, reklama ili mamaca za klikove na vidiku.",
  "sign_in_banner.mastodon_is": "Mastodon je najbolji način da budete u toku sa onim što se dešava.",
  "sign_in_banner.sign_in": "Prijavite se",
  "sign_in_banner.sso_redirect": "Prijavite se ili se registrujte",
  "status.admin_account": "Otvori moderatorsko okruženje za @{name}",
  "status.admin_domain": "Otvori moderatorsko okruženje za {domain}",
  "status.admin_status": "Otvori ovu objavu u moderatorskom okruženju",
  "status.block": "Blokiraj @{name}",
  "status.bookmark": "Dodaj u obeleživače",
  "status.cancel_reblog_private": "Ukloni podršku",
  "status.cannot_reblog": "Ova objava se ne može podržati",
  "status.copy": "Kopiraj vezu u objavu",
  "status.delete": "Izbriši",
  "status.detailed_status": "Detaljan prikaz razgovora",
  "status.direct": "Privatno pomeni @{name}",
  "status.direct_indicator": "Privatno pominjanje",
  "status.edit": "Uredi",
  "status.edited": "Poslednje uređivanje {date}",
  "status.edited_x_times": "Uređeno {count, plural, one {{count} put} other {{count} puta}}",
  "status.favourite": "Omiljeno",
  "status.filter": "Filtriraj ovu objavu",
  "status.history.created": "{name} napisao/la {date}",
  "status.history.edited": "{name} uredio/la {date}",
  "status.load_more": "Učitaj još",
  "status.media.open": "Kliknite za otvaranje",
  "status.media.show": "Kliknite za prikaz",
  "status.media_hidden": "Multimedija sakrivena",
  "status.mention": "Pomeni @{name}",
  "status.more": "Još",
  "status.mute": "Ignoriši @{name}",
  "status.mute_conversation": "Ignoriši razgovor",
  "status.open": "Proširi ovu objavu",
  "status.pin": "Zakači na profil",
  "status.read_more": "Pročitajte više",
  "status.reblog": "Podrži",
  "status.reblogged_by": "{name} je podržao/la",
  "status.reblogs.empty": "Još uvek niko nije podržao ovu objavu. Kada bude podržana, pojaviće se ovde.",
  "status.redraft": "Izbriši i preoblikuj",
  "status.remove_bookmark": "Ukloni obeleživač",
  "status.replied_to": "Odgovor za {name}",
  "status.reply": "Odgovori",
  "status.replyAll": "Odgovori na niz",
  "status.report": "Prijavi @{name}",
  "status.sensitive_warning": "Osetljiv sadržaj",
  "status.share": "Podeli",
  "status.show_less_all": "Prikaži manje za sve",
  "status.show_more_all": "Prikaži više za sve",
  "status.show_original": "Prikaži orginal",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Prevedi",
  "status.translated_from_with": "Prevedeno sa {lang} koristeći {provider}",
  "status.uncached_media_warning": "Pregled nije dostupan",
  "status.unmute_conversation": "Ne ignoriši razgovor",
  "status.unpin": "Otkači sa profila",
  "subscribed_languages.lead": "Samo objave na označenim jezicima će se pojavljivati na početnoj liniji i na listama posle ove izmene. Kada nijedan jezik nije izabran, primaćete objave na svim jezicima.",
  "subscribed_languages.save": "Sačuvaj izmene",
  "subscribed_languages.target": "Promeni jezike na koje je {target} prijavljen",
  "tabs_bar.home": "Početna",
  "tabs_bar.notifications": "Obaveštenja",
  "time_remaining.days": "Ostalo {number, plural, one {# dan} few {# dana} other {# dana}}",
  "time_remaining.hours": "Ostalo {number, plural, one {# sat} few {# sata} other {# sati}}",
  "time_remaining.minutes": "Ostalo {number, plural, one {# minut} few {# minuta} other {# minuta}}",
  "time_remaining.moments": "Još nekoliko trenutaka",
  "time_remaining.seconds": "Ostalo {number, plural, one {# sekund} few {# sekunde} other {# sekundi}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} osoba} few {{counter} osobe} other {{counter} osoba}} u proteklih {days, plural, one {dan} other {{days} dana}}",
  "trends.trending_now": "U trendu sada",
  "ui.beforeunload": "Vaš nacrt će biti izgubljen ako napustite Mastodon.",
  "units.short.billion": "{count} mlrd.",
  "units.short.million": "{count} mil.",
  "units.short.thousand": "{count} hilj.",
  "upload_area.title": "Prevucite i otpustite za otpremanje",
  "upload_button.label": "Dodaj slike, video ili audio datoteku",
  "upload_error.limit": "Dostignuto je ograničenje za otpremanje datoteka.",
  "upload_error.poll": "Otpremanje datoteka nije dozvoljeno kod anketa.",
  "upload_form.edit": "Uredi",
  "upload_progress.label": "Otpremanje...",
  "upload_progress.processing": "Obrada…",
  "username.taken": "To korisničko ime je zauzeto. Pokušajte drugo",
  "video.close": "Zatvori video",
  "video.download": "Preuzimanje datoteke",
  "video.exit_fullscreen": "Izađi iz režima celog ekrana",
  "video.expand": "Proširi video",
  "video.fullscreen": "Ceo ekran",
  "video.hide": "Sakrij video",
  "video.pause": "Pauziraj",
  "video.play": "Reprodukuj"
}
